export const CreateModelSuggestion = [
	{
		selector: '[data-tut="ModelName"]',
		content: "Model name: What would you like your model to be displayed as?",
		stepInteraction: false
	},
	{
		selector: '[data-tut="Response"]',
		content: "Response: What is the variable you want to model?",
		stepInteraction: false
	},
	{
		selector: '[data-tut="FixedModel"]',
		content:
			"Fixed model: Define your fixed model by selecting variables and operators (interaction or nested effects and sum of factors in the model).",
		stepInteraction: false
	},
	{
		selector: '[data-tut="RandomModel0"]',
		content:
			"Random model: Define your random model by selecting variables  and operators (Interaction or nested effects, Heterogeneous structure by group factor and Joining of random terms (e.g. random regression)).",
		stepInteraction: false
	},
	{
		selector: '[data-tut="RandomModelPlus"]',
		content: "Click the + sign to add another random term.",
		stepInteraction: false
	},
	{
		selector: '[data-tut="VarianceStructureRD"]',
		content:
			"Variance structure: Click to select the variance structure of the random term.",
		stepInteraction: false
	},
	{
		selector: '[data-tut="Residual0"]',
		content:
			"Define your residual selecting variables and operators (Interaction or nested effects, Heterogeneous structure by group factor).",
		stepInteraction: false
	},
	{
		selector: '[data-tut="ResidualPlus"]',
		content: "Click the + sign to add another term",
		stepInteraction: false
	},
	{
		selector: '[data-tut="VarianceStructureRes"]',
		content:
			"Variance structure:  Click to define the variance-covariance model for the residual term.",
		stepInteraction: false
	}
]
